var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 1.33331C9.87176 1.33331 9.58731 1.61776 9.58731 1.96823C9.58731 2.31871 9.87176 2.60315 10.2222 2.60315H12.499L7.23364 7.86853C6.9857 8.11647 6.9857 8.51841 7.23364 8.76635C7.35777 8.89048 7.52001 8.95236 7.68255 8.95236C7.84509 8.95236 8.00733 8.89048 8.13146 8.76635L13.3968 3.50097V5.77776C13.3968 6.12823 13.6813 6.41268 14.0318 6.41268C14.3822 6.41268 14.6667 6.12823 14.6667 5.77776V1.96823C14.6667 1.61776 14.3822 1.33331 14.0318 1.33331H10.2222ZM3.23811 1.96823C2.18763 1.96823 1.33334 2.82252 1.33334 3.873V12.7619C1.33334 13.8124 2.18763 14.6666 3.23811 14.6666H12.127C13.1775 14.6666 14.0318 13.8124 14.0318 12.7619V8.95236C14.0318 8.60188 13.7473 8.31744 13.3968 8.31744C13.0464 8.31744 12.7619 8.60188 12.7619 8.95236V12.7619C12.7619 13.112 12.4772 13.3968 12.127 13.3968H3.23811C2.88795 13.3968 2.60318 13.112 2.60318 12.7619V3.873C2.60318 3.52284 2.88795 3.23808 3.23811 3.23808H7.04763C7.39811 3.23808 7.68255 2.95363 7.68255 2.60315C7.68255 2.25268 7.39811 1.96823 7.04763 1.96823H3.23811Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.566f4de0e07f576a321c507284ac33a3.svg";
export { ForwardRef as ReactComponent };